import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { MapState } from '../reducer';

export default function ChartActions(): ReactElement {
  const [isOpen, setOpen] = useState(false);
  const { isAnonymous, createArticle, createMemberTip, createImage, createPaKryss } = useSelector(
    (state: { map: MapState }) => state.map.configuration
  );
  if (isAnonymous) {
    return null;
  }
  return (
    <div id="chart-actions-menu" className={`hb-container content-bg ${isOpen ? 'open' : 'closed'}`}>
      <div className="chart-actions-title">
        <h3>
          <span className="disable-select">Lägg till innehåll</span>
          <div
            onClick={(): void => {
              setOpen(!isOpen);
            }}
          >
            <div className="hb-toggle">
              <div className="hb-toggle-icon" />
            </div>
          </div>
        </h3>
      </div>
      {!isAnonymous && (
        <div id="chart-action-items" className="hb-item-content">
          <div className="chart-action-items-inner hb-item-content-inner">
            <div id="chart-info">
              <a href="/sjokort/medlemstips-och-kartbilder">
                <span className="chart-info-icon" />
                <span className="chart-info-text">Info om hur du skapar medlemstips och bild på sjökortet</span>
              </a>
            </div>
            <ul>
              {createArticle && (
                <li className="disable-select">
                  <a href="/node/add/article" className="btn btn-default chart-btn">
                    <span className="btn-icon article-add" />
                    Skapa artikel
                  </a>
                </li>
              )}
              {createPaKryss && (
                <li className="disable-select">
                  <a href="/node/add/pa_kryss" className="btn btn-default chart-btn">
                    <span className="btn-icon article-add" />
                    Skapa På kryss
                  </a>
                </li>
              )}
              {createMemberTip && (
                <li className="disable-select">
                  <a href="/node/add/membertip" className="btn btn-default chart-btn">
                    <span className="btn-icon star-add" />
                    Skapa medlemstips
                  </a>
                </li>
              )}
              {createImage && (
                <li className="disable-select">
                  <a href="/node/add/mapimage" className="btn btn-default chart-btn">
                    <span className="btn-icon image-add" />
                    Skapa bild
                  </a>
                </li>
              )}
              <li className="disable-select">
                <a href="/sjokort/mina-bidrag" className="btn btn-default chart-btn">
                  <span className="btn-icon edit" />
                  Redigera
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
